import React from 'react';
import AppSidebar from "@/components/AppSidebar.tsx";
import FlashMessage from "@/components/FlashMessage.tsx";

type LayoutProps={
    children:React.ReactNode;
}
const MainLayout:React.FC<LayoutProps> = ({children}) => {
    return (
        <div className={"flex h-screen bg-background dark"}>
            <AppSidebar />
            <main className="flex-1 overflow-auto">
                <FlashMessage/>
                {children}
            </main>
        </div>
    );
};

export default MainLayout;